import { SESSION_STORAGE_KEY } from './sessionTracker';

// 通常画面の一時データを破棄しても、タブ間共有の利用セッションは終了しない。
export function clearPageStorage() {
    // clear() 後の復元では他タブに削除が通知されるため、残すキーには触れない。
    for (const key of Object.keys(localStorage)) {
        if (key !== SESSION_STORAGE_KEY) localStorage.removeItem(key);
    }
}
